import { render, staticRenderFns } from "./testquesttxt.vue?vue&type=template&id=0cfed3ae&scoped=true&"
import script from "./testquesttxt.vue?vue&type=script&lang=js&"
export * from "./testquesttxt.vue?vue&type=script&lang=js&"
import style0 from "./testquesttxt.vue?vue&type=style&index=0&id=0cfed3ae&lang=less&scoped=true&"
import style1 from "./testquesttxt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfed3ae",
  null
  
)

export default component.exports